<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
  <div class="fill-date" [ngClass]="{'invalid-field': !valid && fieldSubmission.field.mandatory }">
    <core-helpers-forms-datepicker
        [theme]="'dp-forms'"
        [minDate]="false"
        [closeOption]="false"
        [selectedDate]="date | date: 'yyyy-MM-dd'"
        (selectDate)="onDateSelect($event)"
    ></core-helpers-forms-datepicker>
  </div>
</div>